import React from 'react';
import {Anchor, Breadcrumbs} from "@mantine/core";
import {useNavigate} from "react-router-dom";
import S from './Article3.module.scss';
import article1 from "../../shared/assets/images/article1.png";
import article2 from "../../shared/assets/images/article2.png";
import article3 from "../../shared/assets/images/article3.png";
import article4 from "../../shared/assets/images/article4.png";

export const Article3 = () => {
    const navigate = useNavigate();

    const items = [
        { title: 'Главная', url: '/' },
        { title: 'Статьи', url: '/articles-list' },
        { title: 'Статья', active: true },
    ].map((item, index) => (
        <Anchor onClick={() => item.url && navigate(item.url)} key={index} data-active={item.active || undefined}>
            {item.title}
        </Anchor>
    ));
    return (
        <section id='article3'>
            <div className={S.content}>
                <div>
                    <Breadcrumbs>
                        {items}
                    </Breadcrumbs>
                    <div className={S.infoDiv}>
                        <div className={S.title}>УМ, СТАЛЬ И ТРУБЫ НАШЕЙ ЭПОХИ</div>
                        <div className={S.picture}>
                            <img src={article3} alt="article3"/>
                        </div>
                        <div className={S.textDiv}>
                            <div className={S.text}>
                                Искусственный интеллект остается главным бизнес-ньюсмейкером. Только говорят уже не о
                                том,
                                что и с какой скоростью научились делать нейросети, а о том, сколько на этом можно
                                заработать. В лидеры имеют шансы выйти промышленные гиганты, в которых даже небольшое
                                сокращение издержек за счет ИИ измеряется миллиардами рублей.
                            </div>
                            <div className={S.articleTitleDiv}>
                                ИИ с характером
                            </div>
                            <div className={S.text}>
                                Металлургическая промышленность, к которой эпитет «традиционная» применяется гораздо
                                чаще,
                                чем «инновационная», одной из первых ощутила отдачу цифровых инструментов. До 10 %
                                экономии
                                электроэнергии и сырья, плюс 10 % к маржинальности, вдвое меньше несчастных случаев —
                                это
                                реальный экономический эффект, которого российские металлурги уже добились, внедряя
                                технологии на базе искусственного интеллекта (ИИ) и машинного обучения.
                            </div>
                            <div className={S.text}>
                                Показателен опыт «Трубной Металлургической Компании» (ТМК), которая использует
                                ИИ-систему, в
                                частности, для оптимизации процесса выплавки стали. Интеллектуальный помощник сталевара
                                анализирует сотни параметров в режиме реального времени и корректирует процесс плавки —
                                ИИ
                                подбирает химсостав, скорость охлаждения и температуру нагрева. Все это позволило
                                получить
                                эффект не менее одного миллиарда рублей в год за счет сокращения расходов на сырье и
                                энергоресурсы.
                            </div>
                            <div className={S.text}>
                                Логичным продолжением стало масштабирование ИИ-сервисов на весь процесс работы
                                электросталеплавильного цеха: формирование шихтовок, литье заготовок.
                            </div>
                            <div className={S.text}>
                                На многих этапах работают системы машинного зрения, которые в автоматическом режиме
                                контролируют геометрические параметры трубной заготовки при формовке, выявляют дефекты
                                готовой продукции и т. д.
                            </div>
                            <div className={S.text}>
                                Еще один успешно реализованный сценарий — использование ИИ для анализа массива данных с
                                датчиков, установленных на прокатных станах, что помогает предсказывать возможные
                                неисправности задолго до их возникновения.
                            </div>
                            <div className={S.text}>
                                Нашлось для ИИ дело и в административных процессах: генеративные нейросети используются
                                в
                                ТМК для поиска определенных фрагментов документации, разработки тестов, анализа
                                договоров и
                                др.
                            </div>
                            <div className={S.text}>
                                «Будущее металлургической отрасли неразрывно связано с развитием искусственного
                                интеллекта.
                                По мере совершенствования алгоритмов и накопления данных эффективность таких систем
                                будет
                                только расти. Это означает, что металлургические предприятия, интегрирующие ИИ в свои
                                процессы, получат значительное конкурентное преимущество на рынке, где точность
                                прогнозирования и оптимизация затрат становятся ключевыми факторами успеха», — считает
                                заместитель генерального директора ТМК по информационным технологиям Дмитрий Якоб.
                            </div>
                            <div className={S.text}>
                                По его словам, дальнейшая эволюция технологии подразумевает интеграцию ИИ-инструментов в
                                систему принятия управленческих решений, создание самонастраивающихся систем, способных
                                анализировать большие данные в реальном времени.
                            </div>
                            <div className={S.text}>
                                Создание фундамента для «умного» производства в ТМК началось в 2019 году — с запуска
                                программы «Цифровое производство ТМК». Несмотря на изменение внешней ситуации и
                                возникшие трудности с доступом к технологиям, активность в этом направлении не
                                снижалась. Компания перешла на отечественные продукты, в том числе собственной
                                разработки. Выполнен основной этап развития системы технического обслуживания и ремонта
                                оборудования (ТОРО), ее возможности расширяются с использованием мобильного ТОРО.
                                Продолжается внедрение в цехах MES-систем (для управления производством), PIMS (сбор
                                технологических данных и событий) и слежения за продукцией. В интеграции с ними
                                готовится к продуктивной работе новая система управления испытаниями продукции в
                                лабораториях предприятий (LIMS).
                            </div>
                            <div className={S.text}>
                                Основным синхронизирующим элементом стал проект MES. «Экспертиза, наработанная в ходе
                                внутренних внедрений и работы с внешними поставщиками решений, позволила нам запустить
                                разработку MES-решений собственными силами. Тех, что максимально адаптированы для
                                сталеплавильного и трубопрокатного производства с учетом специфики ТМК. Это позволяет
                                нам оптимизировать затраты, контролировать качество, оперативно вносить изменения и
                                сохранить контроль над архитектурой и развитием систем, что важно для долгосрочной
                                эффективности», — рассказал Дмитрий Пьянков, директор департамента функционального
                                проектирования бизнес-процессов производства ТМК++, собственного IТ-кластера Группы ТМК.
                            </div>
                            <div className={S.articleTitleDiv}>Сохранить «сеньоров», набрать «джунов»</div>
                            <div className={S.text}>
                                Один из главных вызовов, с которым сегодня сталкиваются все IТ-компании, — это дисбаланс
                                между опытными IТ-специалистами и новичками. На фоне большого прироста численности
                                junior-специалистов, которых массово готовят практически все вузы, ссузы и курсы
                                переквалификации, наблюдается дефицит сотрудников уровня middle и senior. Такой
                                дисбаланс усиливает конкуренцию за опытных специалистов, а значит ключевой задачей для
                                бизнеса становится их удержание.
                            </div>
                            <div className={S.text}>
                                В таких условиях реальному сектору приходится конкурировать с бигтехом. «Стандартным
                                соцпакетом сегодня никого не удивишь, поэтому помимо ДМС, путевок в санатории, оплаты
                                детских оздоровительных лагерей, программы поддержки здорового питания „Тарелка
                                здоровья“, мы предлагаем сотрудникам возможность занятий спортом, а также удаленный или
                                гибридный формат работы. Кроме того, развиваем корпоративную культуру — через ценности,
                                разделяемые всеми сотрудниками, постоянные открытые коммуникации с командой, регулярные
                                очные встречи команд для выработки стратегических решений и многое другое», — говорит
                                директор по управлению персоналом ТМК++ Мария Ворсина.
                            </div>
                            <div className={S.text}>
                                Впрочем, приток молодой крови тоже нужен. Самым эффективным методом привлечения
                                талантов, по ее мнению, является сотрудничество компании с вузами. Поэтому в ТМК++
                                решили создать для студентов Института радиоэлектроники и информационных технологий
                                Уральского федерального университета специальную образовательную траекторию, чтобы
                                погрузить их в специфику работы на реальном производстве. Осенью 2024 года был запущен
                                специальный курс «Индустриальные IТ-системы и кибербезопасность». Активно сотрудничает
                                ТМК и с Волгоградским государственным техническим университетом, в филиале которого в
                                городе Волжском работники компании с этого года преподают курс «Цифровые технологии».
                            </div>
                            <div className={S.text}>
                                Так бизнес вкладывается в подготовку специалистов, которые будут курировать цифровую
                                трансформацию в ближайшем будущем и обеспечивать развитие технологий искусственного
                                интеллекта для реального сектора экономики, чтобы повышать эффективность, снижать
                                издержки и минимизировать человеческие ошибки.
                            </div>
                            <div className={S.hrefDiv}>
                                <span className={S.textBold}>Источник:</span>
                                <a href="ИИС «Металлоснабжение и сбыт»: https://ko.ru/articles/um-stal-i-truby-nashey-epokhi"
                                >ИИС «Металлоснабжение и сбыт»: https://ko.ru/articles/um-stal-i-truby-nashey-epokhi</a>
                            </div>
                        </div>
                        <div className={S.articleTitleDiv}>Читайте также</div>
                        <div className={S.articlesDiv}>
                            <div className={S.articleDiv} onClick={() => navigate('/article1')}>
                                <div className={S.pictureArticle}>
                                    <img src={article1} alt="article1"/>
                                </div>
                                <div className={S.articleDivText}>Ольга Калашникова, начальник управления экологии ПАО
                                    «Северсталь»: «Будущее
                                    принадлежит
                                </div>
                                <p className={S.articleDivDate}>26.02.2025</p>
                            </div>
                            <div className={S.articleDiv} onClick={() => navigate('/article2')}>
                                <div className={S.pictureArticle}>
                                    <img src={article2} alt="article2"/>
                                </div>
                                <div className={S.articleDivText}>Цифровизация экономических отношений в энергетике
                                </div>
                                <p className={S.articleDivDate}>24.04.2025</p>
                            </div>
                            <div className={S.articleDiv} onClick={() => navigate('/article4')}>
                                <div className={S.pictureArticle}>
                                    <img src={article4} alt="article4"/>
                                </div>
                                <div className={S.articleDivText}>Цифровизация в обучении ремонтников Уральской Стали
                                </div>
                                <p className={S.articleDivDate}>23.12.2024</p>
                            </div>
                        </div>
                    </div>
                    <div className={S.footer}>
                        <div onClick={() => navigate('/articles-list')}>← Назад к списку</div>
                    </div>
                </div>
            </div>
        </section>
    );
};